var _defs, _rect, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrDesfa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c3aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d28d9"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#g2)",
    rx: 20,
    ry: 20
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    fill: "#fff",
    fontSize: 90,
    fontFamily: "Arial, Helvetica, sans-serif",
    textAnchor: "middle",
    alignmentBaseline: "middle"
  }, "DS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "72%",
    fill: "#ffffff",
    fontSize: 20,
    fontFamily: "Arial, Helvetica, sans-serif",
    textAnchor: "middle"
  }, "drg. Desfa")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrDesfa);
export default __webpack_public_path__ + "static/media/dr-desfa.e688b26b696dd5231bce762b69b25a85.svg";
export { ForwardRef as ReactComponent };